import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Auth0ProviderWithNavigate from "./Auth0ProviderWithNavigate";
import LoadingScreen from "./loading/loading";
import useAuthToken from "./service/userAuth/useAuth";
import "react-datepicker/dist/react-datepicker.css";
import { ProfileCommissionProvider } from "./context/ProfileCommissionContext/ProfileCommisionContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { store } from "./store/store";
import AuthInitializer from "./auth/authInitalizer";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const Main: React.FC = () => {
  const { token, loading } = useAuthToken(clientId || "");
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (!loading && token) {
    } else if (!loading) {
    }
    setIsInitialized(true);
  }, [loading, token]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Auth0ProviderWithNavigate>
         <AuthInitializer /> 

          <ProfileCommissionProvider>
            <App />
          </ProfileCommissionProvider>
        </Auth0ProviderWithNavigate>
      </QueryClientProvider>

    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <Provider store ={store}>

    <Main />

    </Provider>
  </React.StrictMode>
);

reportWebVitals();
